import React from 'react'
import AlumniDash from '../../Components/AlumniComponent/AlumniDash/AlumniDash';
import SharedJobs from '../../Components/AlumniComponent/JobSharing/SharedJobs';


function JobSharedPage() {
  return (
    <AlumniDash>
        <SharedJobs/>
    </AlumniDash>
  )
}

export default JobSharedPage